// extracted by mini-css-extract-plugin
export var genemodInput = "Input-module--genemodInput--gpg7A";
export var genemodInputContainer = "Input-module--genemodInputContainer--j3kl6";
export var genemodInputWrapper = "Input-module--genemodInputWrapper--ho11-";
export var genemodInputWrapper__lightmode = "Input-module--genemodInputWrapper__lightmode--iK1J2";
export var genemodInput__error = "Input-module--genemodInput__error--PPYaG";
export var inputError = "Input-module--inputError--oJrVm";
export var inputLabel = "Input-module--inputLabel--e-jsc";